import Form from 'react-bootstrap/Form'
import Typography from '../../Typography/Typography'

import './Radio.scss'

const Radio = ({ name, label, value, onChange, error, touched, color = 'blue', ...props }) => {
    const isError = error && touched

    return (
        <Form.Check isInvalid={isError} className={`radio radio--${color} d-flex align-items-center`}>
            <Form.Check.Input
                type={'radio'}
                name={name}
                value={value}
                isInvalid={isError}
                className={'me-2 my-auto'}
                onChange={onChange}
                role={'button'}
                {...props}
            />
            <Typography color={isError && 'error'} variant={'formLabel'} className={'text-capitalize'}>
                {label}
            </Typography>
        </Form.Check>
    )
}

export default Radio
